export default "__VITE_ASSET__57def7e5__"